module.exports = __webpack_public_path__ + "static/img/notext-starroad.964e70f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-starroad.png
// module id = 974+
// module chunks = 1